module.exports = __webpack_public_path__ + "img/brand_2.e9aa6285.png";